import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../@/components/ui/select";
import states from "../assets/states.json";

interface StatesDropdownMenuProps {
  selectedState: string | undefined;
  error: boolean;
  setSelectedState: (state: string) => void;
}

const StatesDropDown: React.FC<StatesDropdownMenuProps> = ({
  selectedState,
  error,
  setSelectedState,
}) => {
  const handleStateChange = (newState: string) => {
    setSelectedState(newState);
  };

  return (
    <Select value={selectedState} onValueChange={handleStateChange}>
      <SelectTrigger
        className={`mt-1 w-full border ${
          error ? "border-red-500" : "border-gray-300"
        } px-4 py-5 xxl:py-6 focus:border-none focus:outline-customGreenColor rounded-lg`}
      >
        <SelectValue placeholder="Select a state" />
      </SelectTrigger>
      <SelectContent className="w-full max-h-60 overflow-y-auto">
        <SelectGroup>
          <SelectLabel className="text-left">Select State</SelectLabel>
          {states.map((state: string, index: number) => (
            <SelectItem key={index} value={state}>
              {state}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default StatesDropDown;
